module.exports = __webpack_public_path__ + "img/WOOCOMMERCE_TEXT.59ec7ff5.svg";